"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateRange = void 0;
/** Returns true if `value` is a [[DateRange]] type. */
function isDateRange(value) {
    // TODO: Check if dates?!
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
exports.isDateRange = isDateRange;
//# sourceMappingURL=isDateRange.js.map